import { PaginatedQueryParams } from "@/store/types";

export const enum CloseEventType {
	Default  = 0,
	SaveInProgress = 1,
	PostSave = 2,
}

/** Tours Setup */
export interface Tours {
	groupId: number,
	title: string,
	tourId: number,
	tourOrder: number
}
export interface Tour {
	groupId: number,
	title: string,
	tourId: number,
	tourOrder: number,
	tourSteps: TourSteps[],
	functionality: null,
	tourStepsCount: number,
	matrixColumnSize: number,
	matrixRowSize: number,
}
export interface TourSteps {
	comment?: string | null,
	objectID: number,
	duration: any,
	preset?: number | null,
	stepOrder: number,
	tourId: number,
	tourStepId: number,
	title: string
}
export interface TourDevices {
	objectID: number,
	groupId: number,
	title: string,
}

/** Predefined Tours */
export interface PredefinedTour {
	predefiendStep: PredefinedTourStep,
	cellTrigger: boolean | null,
	selectedTourOption: number,
	selectedPredefinedTour: Tour,
	isPausedTour: boolean,
	tourTimeout: number,
	confirmationComment: any,
	currentCamera: any,
	currentCameraIndex: number,
	currentIteration: number,
	durationBasedCamera: boolean,
	camerasStreaming: cameraStreaming[],
	isActive: isActiveCell
}

export interface cameraStreaming {
	isStreaming: boolean,
	index: number
}

export interface isActiveCell {
	isActive: boolean,
	index: number
}

export interface PredefinedTourStep {
	durationTimer: number,
}

export interface TourState {
	Tour: Tour[],
	DeviceList: TourDevices[],
	searchedDeviceList: TourDevices[],
	PredefinedTour: PredefinedTour,
	isInTour: boolean
}

export interface SearchDeviceListQueryParam {
	groupId: number,
	searchTerm: string,
}
export interface TourDevicesPaginatedQueryParams extends PaginatedQueryParams {
	searchTerm?: string | null,
	tourId: number,
	groupId: number,
}

export interface TourDevicesPagedResponse {
	pageNumber: number;
	pageSize: number;
	totalRecords: number;
	data: TourDevices[];
}
